import React from 'react';
import { Controller } from 'react-hook-form';
import { NumberFieldCode as GarnishNumberFieldCode } from '../NumberField';
import type { FormProps, ControlledProps } from './types';

type ComponentProps = React.ComponentProps<typeof GarnishNumberFieldCode>;
type OmittedProps = ControlledProps | 'noticePalette';
type Props = FormProps & Omit<ComponentProps, OmittedProps>;

export const NumberFieldCode = ({ name, control, rules, ...rest }: Props) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      render={({
        field: { onChange, onBlur, value },
        fieldState: { invalid },
      }) => (
        <GarnishNumberFieldCode
          value={value}
          invalid={invalid}
          noticePalette={invalid ? 'caution' : undefined}
          onBlur={onBlur}
          onChangeText={onChange}
          {...rest}
        />
      )}
    />
  );
};
